import type { IHttpRequestRunner } from 'shared/domain/httpRequest/httpRequestRunner';
import { ProtocolAnswerHttpEditRequestModel } from './types';
import { Fetcher } from '../fetcher';
import { ProtocolAnswerInDto } from 'shared/dtos/in/protocolAnswer';
import {
  broadcastUpdatedProtocolAnswer,
  broadcastUpdatedProtocolAnswerError,
} from 'serviceWorker/broadcasts/protocolAnswer';

export class ProtocolAnswerRequestRunner implements IHttpRequestRunner {
  constructor(private fetcher: typeof Fetcher) {}

  async execute(
    request: ProtocolAnswerHttpEditRequestModel
  ): Promise<ProtocolAnswerInDto> {
    if (request.method !== 'PUT') {
      throw new Error(
        'ProtocolAnswerRequestRunner only supports PUT method'
      );
    }

    try {
      const response = await this.fetcher.PUT(
        request.url,
        request.data.protocolAnswerOutDto
      );

      broadcastUpdatedProtocolAnswer(
        response as ProtocolAnswerInDto,
        request.data.uniqueId
      );

      return response as ProtocolAnswerInDto;
    } catch (error) {
      broadcastUpdatedProtocolAnswerError(error, request.data.uniqueId);
      throw error;
    }
  }
}
